import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "@/lib/apiClient";   // registra l'interceptor prima di qualsiasi chiamata

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Installabilità e cache offline ──
// Solo in produzione: in sviluppo un service worker servirebbe versioni
// vecchie del bundle e sembrerebbe che le modifiche non vengano applicate.
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[PWA] registrazione del service worker fallita:", err);
      });
    });
  } else {
    // Se resta registrato da una build di produzione aperta sulla stessa porta,
    // in sviluppo darebbe pagine vecchie: lo togliamo.
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
  }
}
